import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import {AiOutlineMenu, AiOutlineClose} from "react-icons/ai";
import { FormattedMessage } from 'react-intl';
import Select from "react-select";
import { selectStyles } from '../../utils';
import { LANG_ARR } from '../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { set_lang } from '../../redux/slices/langSlice';

const CustomerHeader = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const lang = useSelector(state => state.lang)
  const dispatch = useDispatch();

  return (
    <>
    <header className='py-5 w-full mb-5'>
        <div className=" transition-all w-11/12 max-w-[1600px] mx-auto flex items-center justify-between lg:justify-start space-x-12">
            <Link to="/">
              {/* <img src={location.pathname === "/youths" ? "/images/logo-youth.png" : "/images/terapre.png"} alt="idealign" className="w-[90px]" /> */}
              <img src={"/images/terapre.png"} alt="idealign" className="w-[90px]" />
            </Link>
            
            <div className={`transition-all z-[100] pb-16 pt-10 lg:translate-x-0 lg:pb-0 lg:pt-0  fixed h-full w-[250px] lg:w-auto top-0 right-0 block bg-white shadow-xl lg:shadow-none lg:h-auto lg:static lg:flex items-center lg:space-x-5 flex-grow justify-between ${open ? "transform translate-x-0" : "transform translate-x-[100%]"}`}>
              <button onClick={() => setOpen(false)} className='px-8 block lg:hidden w-full mb-16'>
                <AiOutlineClose className="text-2xl ml-auto"/>
              </button>
              <div className="space-y-5 lg:space-y-0 flex-col justify-center lg:justify-start lg:flex-row flex items-center lg:space-x-5">
                <Link to="/about" className={`hover:text-primary hover:border-b-2 hover:border-primary ${location.pathname === "/about" ? "font-bold  text-primary border-b-2 border-primary" : "font-medium  text-gray-600 "}`}>
                  <FormattedMessage id="about.us" defaultMessage={"About Us"} />
                </Link>
                <Link to="/results" className={`hover:text-primary hover:border-b-2 hover:border-primary ${location.pathname === "/results" ? "font-bold  text-primary border-b-2 border-primary" : "font-medium  text-gray-600 "}`}>
                  <FormattedMessage id="results" defaultMessage={"Results"}/>
                </Link>
                <Link to="/youths" className={`hover:text-primary hover:border-b-2 hover:border-primary ${location.pathname === "/youths" ? "font-bold  text-primary border-b-2 border-primary" : "font-medium  text-gray-600 "}`}>
                  <FormattedMessage id="youths" defaultMessage={"Youths"}/>

                </Link>
                <HashLink smooth to="/#faqs" className={`hover:text-primary hover:border-b-2 hover:border-primary ${location.pathname === "/#faqs" ? "font-bold  text-primary border-b-2 border-primary" : "font-medium  text-gray-600 "}`}>
                  <FormattedMessage id="faqs" defaultMessage={"FAQs"}/>
                </HashLink>
              </div>

              <div className="mt-5 lg:mt-0 space-y-5 lg:space-y-0 flex-col justify-center lg:justify-start lg:flex-row flex items-center lg:space-x-5">
              <a href="https://app.terapre.com" target="_blank">
                <button className='btn btn-primary btn-lg'>
                  <FormattedMessage id="login" defaultMessage={"Login"}/>
                </button>
              </a>
              <HashLink smooth to="/#contact-us" className={`hover:text-primary hover:border-b-2 hover:border-primary ${location.pathname === "/contact-us" ? "font-bold  text-primary border-b-2 border-primary" : "font-medium  text-gray-600 "}`}>
                <FormattedMessage id="contact.us" defaultMessage={"Contact Us"}/>
              </HashLink>
              <div>
              <Select
                options={LANG_ARR}
                value={lang}
                onChange={ val => dispatch(set_lang(val))}
                placeholder="Select Language"
                className='w-[200px] text-sm'
              />
              </div>
              </div>
            </div>
            <button onClick={() => setOpen(true)} className='block lg:hidden'>
              <AiOutlineMenu className="text-2xl"/>
            </button>
        </div>

    </header>
    </>
  )
}

export default CustomerHeader